export type SkipGate = { canSkip: boolean; reason: "skip" | "none" };

export function pruneSkipTimestamps(params: {
  timestamps: readonly string[];
  nowMs?: number;
  windowMs?: number;
}): string[] {
  const { timestamps, nowMs = Date.now(), windowMs = 60 * 60 * 1000 } = params;
  const cutoff = nowMs - windowMs;
  return timestamps.filter((iso) => {
    const t = Date.parse(iso);
    return Number.isFinite(t) && t >= cutoff;
  });
}

export function computeSkipGate(params: {
  isPremium: boolean;
  timestamps: readonly string[];
  maxSkipsPerHour?: number;
}): SkipGate {
  const { isPremium, timestamps, maxSkipsPerHour = 30 } = params;
  if (isPremium) return { canSkip: true, reason: "none" };
  return timestamps.length < maxSkipsPerHour
    ? { canSkip: true, reason: "none" }
    : { canSkip: false, reason: "skip" };
}
